import { Dropdown } from 'react-bootstrap';
import React from 'react'; // Removed unused useRef
import styles from './ContextMenu.module.css';
import { useClickOutside } from '@mantine/hooks';

interface ContextMenuProps {
    align?: 'start' | 'end';
    trigger?: React.ReactNode;
    children: React.ReactNode;
    isOpen?: boolean;
    onToggle: (nextShow: boolean) => void;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
    align = 'end',
    trigger,
    children,
    isOpen,
    onToggle,
}) => {
    // 1. Create the click-outside ref
    // This hook will trigger the callback whenever a click happens
    // outside the element this ref is attached to.
    const ref = useClickOutside(() => {
        if (isOpen) onToggle(false);
    });

    return (
        <div ref={ref} className="d-inline-block">
            <Dropdown
                align={align}
                show={isOpen}
                autoClose={false}
                onToggle={(nextShow) => onToggle(nextShow)}
            >
                <Dropdown.Toggle
                    as="button"
                    type="button"
                    className={`btn btn-no-bg btn-sm ${styles.toggle}`}
                    style={{ cursor: 'pointer' }}
                >
                    {trigger ?? <DefaultTrigger />}
                </Dropdown.Toggle>

                <Dropdown.Menu className={styles.menu}>
                    {React.Children.map(children, (child) => {
                        // 1. Verify it's an object we can actually put props on
                        if (React.isValidElement(child)) {
                            // 2. Cast the child to a ReactElement that includes an optional onClick
                            const element = child as React.ReactElement<{
                                onClick?: React.MouseEventHandler;
                            }>;

                            return React.cloneElement(element, {
                                onClick: (e: React.MouseEvent) => {
                                    // Call the original item's onClick (e.g., the one that opens your Dialog)
                                    element.props.onClick?.(e);

                                    // Close the ContextMenu
                                    onToggle(false);
                                },
                            });
                        }

                        // Return strings, numbers, or nulls as-is
                        return child;
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

const DefaultTrigger = () => <i className="fas fa-lg fa-ellipsis-h" />;
